import { Alert } from 'rsuite';


const DEFAULT_ERROR = 'Error executing the payment';
export const handleTokenError = (resp) => {
  const err = resp.reasons[0].message;
  Alert.error(err || DEFAULT_ERROR)
};
